// extracted by mini-css-extract-plugin
export default {"register":"register_register__ymeXd"};